import { Delete } from "@mui/icons-material"
import { Typography } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import OneInput from "../../../../../../Components/OneInput/OneInput"
import { OneSwitch } from "../../../../../../Components/OneSwitch/OneSwitch"

const CardEventoExceto = ({ eventoExceto, setIdToEdit, index, editPorteiro, deleteEventoExceto }) => {
    const { porteiro, descricao } = eventoExceto

    return (
        <Grid
            xs={12}
            sx={{ alignItems: 'center', paddingTop: '5px' }}
            container
        >
            <Grid container xs sx={{ border: '1px solid grey', padding: '10px', borderRadius: '5px', alignItems: 'center' }}>
                <Grid md={9}>
                    <Grid container sx={{ alignItems: 'center' }}>
                        <Grid xs={12} md={1.1}>
                            <Typography fontSize="13px" fontWeight='400' >Evento: </Typography>
                        </Grid>
                        <Grid xs={12} md={10}>
                            <OneInput
                                defaultValue={descricao}
                                readOnly
                                name={"evento"}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid md={2}>
                    <Grid xs={7} container sx={{ alignItems: 'center' }}>
                        <Grid xs={12} md={3}>
                            <Typography fontSize="13px" fontWeight='400' >Porteiro: </Typography>
                        </Grid>
                        <Grid xs={12} md={8}>
                            <OneSwitch
                                defaultValue={porteiro == 1}
                                readOnly
                                name={"porteiro"}
                                onChange={(e) => editPorteiro(index, e.target.checked)}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid md={1}>
                    <Grid xs={1} container sx={{ alignItems: 'center', justifyContent: 'end' }}>
                        <Delete titleAccess="Deletar horario" sx={{ cursor: 'pointer', fontSize: '18px', color: '#a50b0b' }} onClick={() => deleteEventoExceto(index)} />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default CardEventoExceto
